<template>
<el-row class="task-main" v-if="task">
  <top-nav></top-nav>

  <div class="task-cover" v-show="coverVisible">
    <i class="el-icon-loading"></i>
  </div>

  <el-col :xs="{span:24,offset:0}" :sm="{span:18,offset:3}" class="task-content" :style="taskContentStyle">
    <div v-if="task.id === id" class="task-parameters">
      <div class="task-parameters-table">
        <div v-if="task.title">
          <div class="task-parameters-table-label"><b>Task</b></div>
          <div class="task-parameters-table-content">{{`${task.title}`}}</div>
          <div style="clear:both"></div>
        </div>

        <div v-if="task.par">
          <div class="task-parameters-table-label"><b>Task Type</b></div>
          <div class="task-parameters-table-content">{{task_type===0?'Allosteric Site Prediction':(task_type===1?'Allosteric Pathway and Critical Residues Identification':'Inter-residue ACI Calculation')}}</div>
          <div style="clear:both"></div>
        </div>

        <div v-if="task.par && task_type!==3">
          <div class="task-parameters-table-label"><b>Active Site</b></div>
          <div class="task-parameters-table-content">{{`${task.par.active_site}`}}</div>
          <div style="clear:both"></div>
        </div>

        <div v-if="task.par && task_type===1">
          <div class="task-parameters-table-label"><b>Allosteric Site</b></div>
          <div class="task-parameters-table-content">{{`${task.par.allosteric_site}`}}</div>
          <div style="clear:both"></div>
        </div>

        <div v-if="task.par">
          <div class="task-parameters-table-label"><b># of residues</b></div>
          <div class="task-parameters-table-content">{{`${$store.state.task.results.ind.length}`}}</div>
          <div style="clear:both"></div>
        </div>

        <div v-if="task.par">
          <div class="task-parameters-table-label"><b>Submit Time</b></div>
          <div class="task-parameters-table-content">{{task.tsubmit}}</div>
          <div style="clear:both"></div>
        </div>

        <div v-if="task.par">
          <div class="task-parameters-table-label"><b>Finish Time</b></div>
          <div class="task-parameters-table-content">{{task.tfinish}}</div>
          <div style="clear:both"></div>
        </div>
      </div> <!-- Task Panel -->
    </div> <!-- Task Parameters -->

    <div v-if="task_type===0">
      <aci ref="aci" :value='true'></aci>
    </div>

    <div v-if="task_type===0">
      <bfactor ref="bfactor" :value='true'></bfactor>
    </div>

    <div v-if="task_type===1">
      <path-structure ref="pathStructure" :value='true'></path-structure>
    </div>

    <div v-if="task_type===1">
      <paths ref="paths" :value='true'></paths>
    </div>

    <div v-if="task_type===1">
      <net ref="net" :value='true'></net>
    </div>

    <div v-if="task_type===3">
      <correlation ref="corr" :value='true'></correlation>
    </div>

    <div v-if="task_type===3">
      <dendrogram ref="dendrogram" :value='true'></dendrogram>
    </div>

    <div v-if="task_type===3">
      <cluster ref="cluster" :value='true'></cluster>
    </div>

  </el-col> <!-- task-content -->

</el-row> <!-- task-main -->
</template>

<script>
// import Chart from 'chart.js'
import axios from 'axios'
// import { bus, r2h, interpolateColor } from '../bus.js'
// import { bus } from '../bus.js'
// import interpolate from 'color-interpolate'
import TopNav from './TopNav.vue'

axios.defaults.headers.post['Content-Type'] = 'multipart/form-data'

export default {
  name: 'Task',

  data () {
    return {
      resultTypes: ['ACI', 'bfactor', 'Nodes', 'Paths', 'Structure', 'Correlation'],
      resultTypeVisible: [0, 0, 1, 1, 1, 3],
      resultCount: { 'Targets': 0, 'Compounds': 0, 'Processes': 0, 'Functions': 0 },
      compound: '',
      task: '',
      origTask: '',
      filtersVisible: false,
      coverVisible: false,
      reprs: {},
      representationVisibilities: {}
    }
  },

  components: {
    TopNav,
    Net: () => import('./Net.vue'),
    Paths: () => import('./Paths.vue'),
    PathStructure: () => import('./PathStructure.vue'),
    Bfactor: () => import('./Bfactor.vue'),
    Aci: () => import('./Aci.vue'),
    Cluster: () => import('./Cluster.vue'),
    Correlation: () => import('./Correlation.vue'),
    Dendrogram: () => import('./Dendrogram.vue')
  },

  computed: {
    id () {
      return this.$route.params.id
    },

    task_type () {
      if (this.task) {
        if (this.task.par) {
          return this.task.par.task_type
        } else {
          return -1
        }
      } else {
        return -1
      }
    },

    taskContentStyle () {
      if (this.coverVisible) {
        return {
          position: 'fixed',
          left: '-100%',
          right: '100%'
        }
      } else {
        return {
        }
      }
    }
  },

  methods: {
    databaseLink (db) {
      if (!db || db === 'CHEMBL') {
        return 'https://www.ebi.ac.uk/chembl'
      } else if (db === 'Metabolites') {
        return 'http://www.hmdb.ca/metabolites'
      } else {
        return 'https://zinc15.docking.org'
      }
    },

    redirect (url) {
      window.location.href = url
    },

    openNewTab (url) {
      window.open(url, '_blank')
    },

    post (url, p, cb1 = () => {}, cb2 = () => {}) {
      let parts = [new Blob([JSON.stringify(p)], { type: 'application/json' })]
      let fileToSend = new File(parts, 'front-config.json', {
        type: 'application/json'
      })

      let formData = new FormData()

      formData.append('par', fileToSend)

      axios({
        method: 'post',
        url,
        data: formData,
        config: {headers: {'Content-Type': 'multipart/form-data'}},
        withCredentials: true
      }).then(response => {
        cb1(response)
      }).catch(error => {
        cb2(error)
      })
    },

    check () {
      let v = this
      v.coverVisible = true
      axios({
        method: 'get',
        url: v.$store.state.host + '/dokhlab/actions/ohm/task?id=' + v.id,
        withCredentials: true
      }).then(response => {
        v.task = response.data

        if (v.task) {
          v.task.par = JSON.parse(v.task.par)
          v.task.results = JSON.parse(v.task.results)
          v.task.results.ind = v.task.results.ind.split('\n').filter(i => i.trim() !== '').map(line => {
            let r = line.split(/\s+/)
            //          console.log(r)
            let chain = r[1].split(/\//)[1]
            let residue = r[2].split(/\//)[0]
            return {
              num: parseInt(r[0]),
              name: `${chain}/${residue}`,
              chain,
              residue
            }
          })
          console.log(v.task.results.ind)
          if (v.task.par.task_type === 0) {
            v.task.results.nodes = v.task.results.nodes.split('\n').filter(i => i.trim() !== '').map(i => parseFloat(i.trim()))
            v.$store.commit('setTask', v.task)
          } else if (v.task.par.task_type === 1) {
            v.task.results.paths = v.task.results.paths.split('\n').filter(i => i.trim() !== '').map(line => {
              let r = line.split(/\s+/)
              let weight = parseFloat(r[0])
              let path = r[1].split(/-/)
  //            let path = r[1].split(/-/).map(i => parseInt(i))
              return {
                weight, path
              }
            })
            v.$store.commit('setTask', v.task)
          } else if (v.task.par.task_type === 3) {
            v.$store.commit('setTask', v.task)
          }
          v.coverVisible = false
        } else {
          alert('You have no permissions to view this task!')
        }
      }).catch(error => {
        console.log(error)
        v.coverVisible = false
      })
    },

    toggleRepresentation (t) {
      var v = this
      if (t in v.reprs && v.reprs[t] != null) {
        v.reprs[t].toggleVisibility()
      } else {
        if (t === 'label') {
          v.reprs[t] = v.comp.addRepresentation(t, {
            sele: '.CA',
            color: 'grey',
            radiusScale: 0.7,
            fixedSize: true,
            labelType: 'format',
            labelFormat: '%(chainname)s%(resno)s'
          })
        } else {
          v.reprs[t] = v.comp.addRepresentation(t, {
            probeRadius: 1.5,
            multipleBond: true,
            colorScheme: 'bfactor',
            colorScale: ['blue', 'green', 'yellow', 'red']
          })
        }
      }
      v.checkRenderStatus(function () {
        v.representationVisibilities[t] = v.reprs[t].getVisibility()
      })
    },

    checkRenderStatus (cb) {
      var v = this
      setTimeout(function () {
        var c = v.stage.tasks.count
        if (c !== 0) {
          v.checkRenderStatus(cb)
        } else {
          cb()
        }
      }, 500)
    }

  },

  mounted () {
    let v = this

    v.$nextTick(function () {
      v.check()
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/theme.scss";


.task-cover {
  font-size: 80px;
  width: 100%;
  height: 600px;
  line-height: 600px;
  text-align: center;
}

.task-parameters {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.task-parameters-table {
  width: 520px;
  margin: auto auto auto 10px;
}

.task-parameters-table-label {
  float: left;
  width: 150px;
  max-width: 150px;
  margin: 10px;
}

.task-parameters-table-content {
  margin: 10px;
  float: left;
  width: 320px;
  max-width: 320px;
  max-height: 250px;
}

.task-parameters-img {
  margin: auto 10px auto auto;
}

.task-main {
 font-size: 16px;
 color: $font-grey;
}

.task-result-type-menu {
  font-size: 20px;
  font-weight: 600;
  border-bottom: 1px solid lighten($font-grey, 50%);
  margin-bottom: 20px;
}

.task-result-type-menu-item {
  box-sizing: content-box;
  padding: 30px 0px 30px 0px;
  cursor: pointer;
  border-bottom: 5px solid white;
  text-align: center;
}

.task-result-type-menu-item.menu-item-selected {
  border-bottom: 5px solid $theme-color;
}

.results-menu {
  font-size: 18px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.results-menu-count {
  color: black;
  margin-right: 40px;
  font-weight: 450;
}

.results-menu-filters {
  background-color: #f1f1f1;
  padding: 5px 15px;
  font-weight: 600;
  border: 1px solid lighten($font-grey, 50%);
  margin: 0px auto 0px 0px;
  cursor: pointer;
}

.results-menu-sort-by {
  margin: 0px 5px 0px auto;
}

.results-menu-sort {
  margin: 0px 5px 0px 20px;
  padding: 5px 15px;
  background-color: #f1f1f1;
  font-weight: 600;
  border: 1px solid lighten($font-grey, 50%);
  cursor: pointer;
}

#viewport {
  width: 680px;
  height: 450px;
  box-shadow: 0 0 5px #888888;
}

.section-title {
  font-weight: 700;
}

</style>
